import { useEffect, useState } from 'preact/hooks';

/** A media query, live. One implementation, so every breakpoint hook behaves the same. */
function useMedia(query: string): boolean {
  const [on, setOn] = useState(() =>
    typeof window !== 'undefined' ? window.matchMedia(query).matches : false,
  );
  useEffect(() => {
    const mq = window.matchMedia(query);
    const onChange = () => setOn(mq.matches);
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, [query]);
  return on;
}

/** The system colour scheme, live. */
export function useSystemDark(): boolean {
  return useMedia('(prefers-color-scheme: dark)');
}
